module.exports = __webpack_public_path__ + "static/img/招标-3.3cb61be7.png";